export default __webpack_public_path__ + "static/reward-college-b2d69e15b982519ed95bccb6e072c98f.png";